// extracted by mini-css-extract-plugin
export default {"wrapperFilter":"WrapperFilter_wrapperFilter__2eK-S"};